<template>
  <a
    :class="[b({ select }), 'om-hairline']"
    :href="url"
    @click="onClick"
  >
    <div v-if="isDef(info)" :class="b('info')">{{ info }}</div>
    {{ title }}
  </a>
</template>

<script>
import create from '../utils/create';
import { isDef } from '../utils';

export default create({
  name: 'badge',

  props: {
    url: String,
    info: [String, Number],
    title: String
  },

  beforeCreate() {
    this.$parent.badges.push(this);
  },

  computed: {
    select() {
      return this.$parent.badges.indexOf(this) === this.$parent.activeKey;
    }
  },

  methods: {
    isDef,

    onClick() {
      this.$emit('click', this.$parent.badges.indexOf(this));
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/badge/index.vue